module.exports = __webpack_public_path__ + "img/help-tooltip-info-exclamation.4b0d7b6b.svg";